module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "budget-followup-hours"
  }, [(_vm.data) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "budgetfollowup.hours.graph",
      "placement": "left"
    }
  }), _vm._v("\n                        Solgte timer fordelt pr. måned\n                    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(_vm.data && _vm.hoursGraphSeries.length > 0) ? _c('vue-apex-charts', {
    attrs: {
      "height": 300,
      "series": _vm.hoursGraphSeries,
      "options": _vm.hoursGraphOptions,
      "type": "bar"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "budgetfollowup.hours.yeartodate",
      "placement": "left"
    }
  }), _vm._v("\n                        Budgetåret til dato\n                    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Faktisk")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.data.hours.year_to_date.actual)) + " timer")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Budget")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.data.hours.year_to_date.budget)) + " timer")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Difference")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'color-good': _vm.data.hours.year_to_date.diff > 0, 'color-bad': _vm.data.hours.year_to_date.diff < 0
    }
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.data.hours.year_to_date.diff)) + " timer")])])])])])])]) : _c('div', [_c('box-loading')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-501bbe0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/learning/components/budgetHours.vue
// module id = 864
// module chunks = 0